import { FormControlLabel } from '@mui/material';

import MyDialog from "~/mui/MyDialog";
import { useTrans } from '~/hooks/useTrans';
import { apiUpdateProject } from '~/providers/api';
import { IClientProject, IClientUpdateProject } from '~/providers/client-interfaces';
import { IUrlParams } from "~/interfaces";
import { myUseState } from "~/hooks/myUseState";
import { MySwitch } from "~/mui/MySwitch";
import { IAdminProject } from "~/providers/admin-interfaces";
import { useLang } from "~/hooks/useLang";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
	wasChanged: boolean;
}

interface IProjectApiCallModal {
	params: IUrlParams;
	isInternal: boolean;
	projectData: IClientProject | IAdminProject;
	onSave?: (project: IClientProject | IAdminProject) => void;
	onClose?: () => void;
}

export default function ProjectApiCallModal({
	params = null,
	isInternal = false,
	projectData = null,
	onSave = () => {},
	onClose = () => {},
}: IProjectApiCallModal) {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
		wasChanged: false,
	});
	const { state: stateProject, updateState: updateStateProject } = myUseState<IClientUpdateProject>({
		userTitle: projectData.userTitle,
		userDescription: projectData.userDescription,
		userSwitch: projectData.userSwitch,
		lastUpdate: projectData.lastUpdate,
	});

	function updateSwitch(userSwitch: boolean) {
		const wasChanged = stateProject.userSwitch !== userSwitch;

		updateStateProject({
			userSwitch,
		});
		updateState({
			wasChanged,
		});
	}

	async function dialogOnSave() {
		updateState({
			dialogLoading: true,
			errorMsg: "",
		});


		const outputData = await apiUpdateProject(isInternal ? "admin" : "client", params.projectId, stateProject, lang);

		if (outputData.noErrors) {
			onSave(outputData.data);
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: outputData.errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("projectSettingsModal.title")} onClose={onClose} onSave={dialogOnSave} className="projectSettings" dialogLoading={state.dialogLoading} disableSave={!state.wasChanged} errorMsg={state.errorMsg}
		confirmClose={state.wasChanged}>
		<FormControlLabel
			control={<MySwitch sx={{ m: 1 }} checked={stateProject.userSwitch} onChange={event => updateSwitch(event.target.checked)} />}
			label={trans("projectSettingsModal.userSwitch")}
			sx={{ marginBottom: "var(--margin-large)" }}
		/>
	</MyDialog>;
}
